import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';

@Component({
    selector: 'app-loader',
    imports: [CommonModule, ProgressBarModule],
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  @Input()
  public isProgressBar: boolean = true;

}
